import { SVGProps } from 'react'

export const StarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="currentColor"
      viewBox="0 0 18 18"
      {...props}
    >
      <path d="M9.44 14.833a.863.863 0 0 0-.882 0l-4.163 2.486c-.645.386-1.442-.185-1.27-.909l1.103-4.66a.832.832 0 0 0-.27-.824L.293 7.782C-.274 7.294.03 6.375.78 6.312l4.828-.404a.851.851 0 0 0 .712-.508l1.895-4.39c.294-.68 1.274-.68 1.568 0l1.895 4.39a.851.851 0 0 0 .712.508l4.828.404c.75.063 1.055.982.487 1.47l-3.663 3.144a.832.832 0 0 0-.27.824l1.103 4.66c.171.725-.626 1.295-1.271.91L9.44 14.833Z" />
    </svg>
  )
}
